/* components/AccordionContainer.ts

Standard Accordion Component
Content slides up or down depending on whether it has class 'accordion--open'

Use within liquid as:
{! component 'AccordionContainer', header: 'This is an Example', content: accordionContent, class:'example__class' !}

*/
import { Component, Ref, Prop } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { removeNodes } from 'lit-html';

import "./Accordion.scss";

@Component
export class AccordionContainer extends ThemeComponent {
    @Prop({ default: null }) breakpoint!: number;

    init() {

        // If responsive breakpoint has been added
        if (this.breakpoint !== null) {

            // Accordion should only be active below specified breakpoint
            const mmBreakpoint = window.matchMedia(`(min-width: ${this.breakpoint + 1}px)`);

            // Check breakpoint, either add or remove click listeners
            const breakpointChecker = () => {
                if (mmBreakpoint.matches) {
                    this.removeAccordionListeners();
                    return;
                } else {
                    this.addAccordionListeners();
                }
            };

            // Init listener and initial check
            breakpointChecker();
            mmBreakpoint.addEventListener('change', () => {
                breakpointChecker();
            });
            return;
        } else {
            this.addAccordionListeners();
        }

    }

    openContainer(clickedHeader: HTMLElement, allHeaders: NodeListOf<HTMLElement>) {
        if (clickedHeader) {

            // ------------------------------------------
            // TODO The following functionality has been commented
            // while the client reviews the change for accordion
            // sections to remain open until closed.
            // Once approved, this functionality can be removed.
            // ------------------------------------------

            // for (const header of allHeaders) {

            //     if (header !== clickedHeader) {
            //         header.classList.remove('accordion__header--active');
            //     }
            // }

            // Target the adjacent accordion body and apply a heigh
            const accordionBody = clickedHeader.nextElementSibling as HTMLElement;
            const accordionBodyHeight = accordionBody?.scrollHeight;
            if (accordionBodyHeight) {
                accordionBody.style.height = 'auto';
            }
            clickedHeader?.classList.add('accordion__header--active');

            // Ensure the newly selected accordion item is in the viewport
            // clickedHeader.scrollIntoView();
        }
    }

    addAccordionListeners() {
        this.addEventListener('click', this.addListeners);
    }

    removeAccordionListeners() {
        this.removeEventListener('click', this.addListeners);
    }

    addListeners(event: Event) {

        const clickedHeader: HTMLElement | null = (event.target as HTMLElement)?.closest('.accordion__header');
        const allHeaders: NodeListOf<HTMLElement> | null = this.querySelectorAll('.accordion__header');

        if (clickedHeader?.classList.contains('accordion__header--active')) {
            clickedHeader.classList.remove('accordion__header--active');
            return;
        }
        if (clickedHeader && allHeaders) {
            this.openContainer(clickedHeader, allHeaders);
        }

    }
}
